import classNames from 'classnames'
import * as React from 'react'
import { Hours, Location } from 'src/types/schema/graphql'
import { sortSameBusinessHours } from '../../utils/helpers'
import CurrentDayStatus from './CurrentDayStatus'
import { FormattedRow } from './FormattedRow'
interface ILocation {
    location: Location
}

const BusinessHours: React.FC<ILocation> = ({ location }) => {
    const [sortedDays, setSortedDays] = React.useState<Hours[][]>([])
    React.useEffect(() => {
        setSortedDays(sortSameBusinessHours(location.hours))
    }, [])

    return (
        <div className='w-full'>
            <CurrentDayStatus location={location} />
            <div className='mt-7 w-full'>
                {sortedDays.map((dataArr, i) => {
                    const isLast = i === sortedDays.length - 1
                    return (
                        <div
                            className={classNames(
                                !isLast && 'mb-3 w-full border-b-px border-gray-100'
                            )}
                            key={dataArr[0].day}
                        >
                            <div
                                className={classNames(
                                    'flex flex-row justify-between',
                                    !isLast && 'pb-3'
                                )}
                            >
                                {dataArr[0].isOpen ? (
                                    <>
                                        <p>
                                            {dataArr[0]?.day}
                                            {dataArr.length > 1 && (
                                                <span> - {dataArr[dataArr.length - 1].day} </span>
                                            )}
                                        </p>
                                        <FormattedRow dayObj={dataArr[0]} />
                                    </>
                                ) : (
                                    <>
                                        <p>
                                            {dataArr[0]?.day}
                                            {dataArr.length > 1 && (
                                                <span> - {dataArr[dataArr.length - 1].day} </span>
                                            )}
                                        </p>
                                        <p>Closed</p>
                                    </>
                                )}
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default BusinessHours
